module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "CHAPTER-",
    attrs: {
      "id": "u28RQEPNPQXgoSmq96OXTiB",
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "uUGQ56DG6JGBsgcDBpwmkBE"
    }
  }), _vm._v("Crashing Down")]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "italics"
  }, [_vm._v("D.P.E. Archangel, Over Highland")])]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', [_vm._v("Dr. Tier glared at Timberwolf. He looked back, a smile on the edge of his mouth. They sat opposite each other in the drop-lifter as technicians and security personnel secured themselves around them. ")]), _c('span', {
    staticClass: "italics"
  }, [_vm._v("He better be there, ")]), _c('span', [_vm._v("her eyes said. Timberwolf had told her Gray was trapped below within a stasis pod. He had locked him in there and used his location to bargain for Salla Birdwing’s life. She had been sent away on a shuttle, and hopefully she’d scrambled her transponder.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Dr. Tier’s whole staff was aboard the lifter, even Conrad Stonefield. Timberwolf had heard whiffs about the young analyst stepping in to deal with Cardinal Jacob for some reason. He was dying to know the story behind that.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Release in 5, 4, 3…” The pilot left the last part unspoken, and the drop-lifter detached from the belly of "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("Archangel")]), _vm._v(" with a nudge. The weightlessness came a moment later once they were outside of the cruiser’s gravity field. Dr. Tier’s hair lifted off her shoulders, and Timberwolf couldn’t help but smile.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What?” she demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Nothing. Did I tell you that Kizik is gone? Not in my head anymore.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes, you keep saying that.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Mission accomplished,” he grinned, showing his hands like a card dealer.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You’ve been given ‘ownership’ of the Highland facility below, apparently, by the A.I. that ran it. You want to stay there? Fix up the property?”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He nodded. He’d failed Dr. Tier in so many ways. He’d failed to secure Highland, failed to keep the Dacha brothers alive, and the facility below smoldered from a nuclear blast. His only saving grace was that Gray, the man who was the architect behind all this chaos, was trapped below. He had no doubt whatsoever that if he wasn’t, then Tier wouldn’t let him live one hour. She’d put a blast in him and let the swirling dust and snow of Highland cover his body.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "italics"
  }, [_vm._v("Funny,")]), _vm._v(" he considered– just when he wanted to live, forces might finally converge to kill him. Kizik, the Arnock alien spider, was no longer a passenger in his head. He couldn’t hear the grinding any longer, wasn’t enduring the mental torture. Even as he descended into utter uncertainty, he was almost giddy. Part of it was Salla, helping her escape and earning her freedom for her. It was the first unselfish thing he’d done in a very long time. He thought of her face, kind and naturally striking. He imagined her pressed up against the window of the shuttle looking back at him. For the moment, he knew she was safe, and that gave him some comfort.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“We can’t safely descend,” the pilot said over her shoulder to Dr. Tier.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It’s not getting any safer. Just descend.” They locked eyes for a moment, and then the pilot sheepishly looked away.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Helmets on. This will be rough!” the pilot advised.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The drop-lifter took a dip towards the world below, and the swirl of the high-cloud layer filled the windscreen. The atmosphere had changed drastically from just a few hours before. Giant weather systems kicked up across the entire planet. The world of Highland looked like an ill Jupiter, its smooth whiteness now replaced by pinwheels of gray and pale orange.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The cabin jerked to the side as they hit the first part of the atmosphere. The pilot corrected manually, taking control of the ship from the A.I. Dr. Tier crunched up her face in aggravation as the pilot hunted for safe entry through the weather. Suddenly, she found a channel and dove almost straight downward.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A deep warbling filled the cabin, and the windscreen shook in its molding. Lightning flashed nearby, and a bolt hung for long seconds just beyond the starboard wing. They broke through layer after layer of clouds, each time like smashing through a pane of glass. In the cabin, heads hung in fetal crash positions, all except Timberwolf and Tier. They were ramrod straight and taking it all in.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Something’s coming at us!” the pilot yelled.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A million shards of the machine cloud, the semi-sentient entity that wrapped the planet, impacted the side of the drop-lifter like sand falling on a tin roof. The swarm moved away and then impacted the other side. The drop-lifter spun, and alarms rang out. The pilot was frantic in her movements, hands flashing to the interfaces. The craft fell in a flat spin now, the G-forces making a tight knot at the top of everyone’s neck.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Suddenly, the scream of the engines was gone, and the pilot silenced the alarm. Timberwolf eyed her going for the emergency retro booster button that would throw them back into the atmosphere. Tier saw it too. “Do not abort this descent!” she commanded.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But the pilot had other plans, the drop-lifter was falling without power, the beveled ground rushing up at them. They were just a few thousand feet above the world now. She hit the button, but just for an instant, and everyone’s heads jerked against the restraints. The ship stopped its descent, but then began falling a few seconds later. She hit the retro again, once more jerking them to a near stop just above the ground. The ship then dropped the last dozen feet and settled on its gimbaled landing gear with an undignified thud.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Dr. Tier’s mouth was open, and she was unusually impressed. “Nicely fucking done,” she complimented the pilot.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The gangplank of the drop-lifter wheezed open, exposing the party to the frigid elements. Snow and dust whipped into frenzied pellets, striking their faces. The others rushed out, wrapped in environment suits, but Dr. Tier grabbed Conrad by the elbow. “Stop!” She tightened his breather, making an airtight seal over his mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Two hundred yards away, the smoldering landing bay threw oily smoke into the sky, its superstructure in jagged collapse. Timberwolf pulled his breather away so he could shout to Tier, “That machine cloud is not friendly. It will come back.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“We get Gray. We get out. That’s the plan,” Dr. Tier responded.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Conrad appeared at Dr. Tier’s elbow, “what about some of the inventory here? Maybe we can salvage some… items?”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Dr. Tier nodded; they needed all the help they could get. Assault Corps cruisers "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("Defender ")]), _vm._v("and"), _c('span', {
    staticClass: "italics"
  }, [_vm._v(" Tranquility, ")]), _vm._v("and possibly "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("Challenger")]), _vm._v(", were incoming. If there were any exotic weapons still intact down here, they might come in handy. “And possibly destroy the rest so it can’t be used against us,” Conrad added.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“That’s a good idea. Manage it,” she ordered.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“When did you get smart?” Timberwolf punched the young desk jockey in the shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("One of the security team piped up, “I’ve got tracks through the snow in infrared. Towards that burning structure.” In unison, the team switched their smart contacts above the visible spectrum and saw the footprints. “Whoever it was is injured, dragging their right foot.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“OK – who’s up for a jog?” Dr. Tier said, making a beeline for the landing bay. “We need to move fast so we don’t get killed down here.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("They ran towards a triangle-shaped gap in the wreckage where the footprints led. They were close when a call came from the drop-lifter. “Doc! I’m in trouble,” came the pilot’s muffled voice.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("They felt something in the ground – a seismic gallop. They turned back to see a monstrous form bearing down on the drop-lifter. It was a massive creature the size of a rhinoceros, with three angry horns protruding through an armored faceplate. “It’s a Trike!” Timberwolf warned – a giant Sabatin used for demolition. They’d attacked the Arnock command ship in orbit, tearing it to shreds.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A security man dropped to his knees and spun up his plasma rifle to fire, but Timberwolf grabbed the barrel. “That thing fell from space! You can’t hurt it. Don’t get its attention.” A second later, the Trike T-boned the drop-lifter, caving it in and smashing it sideways. From the other side, a second Trike joined the game, tearing the back half off the vessel. They tugged at what remained, doing as they were designed and shredding the remnants.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Now the security team let loose, and the staccato pounding of plasma blasts tore through the air. Timberwolf found himself on his belly next to Dr. Tier. He was technically in her custody after everything that had happened, but her eyes begged him to spring into action. This was his kind of moment. Timberwolf thrived in the chaos and bent it to his will.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The Trikes charged at them, moving in fast, straight lines. A security man was flying through the air now, gored by a beast. He landed beside Timberwolf and bounced before laying limp. Timberwolf was up, grabbing the downed man’s plasma rifle. The group edged towards the landing bay, but the Trikes circled them, raging inward to pick them off.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("One of the Trikes had half the armor over its face missing, and deep, white burns stained its mouth and eye. Timberwolf took careful aim and fired, hitting right above its cheek. It stopped immediately, turning its massive face towards him, the plasma bursts from others bouncing off its thick hide. The beast took a bead on him and charged, its rippled shoulder muscles a manifestation of pure power. Timberwolf fired again and again, on auto-blast now. Each burst hit the exact same spot right under its exposed eye, but it wasn’t enough. Just feet away now, the Trike was still coming.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Then suddenly it wasn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "italics"
  }, [_vm._v("No goddam way! ")]), _vm._v("Timberwolf thought as the beast veered away at the last second, shaking its head like it had just tried to break through a security field. "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("Nothing made by Highland can hurt me.")]), _vm._v(" He had thought it might be the case but wasn’t sure how he would find out until just this moment. As the new “owner” of the facility, the executive safety protocols had cascaded down to him.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The other Trike was charging at Dr. Tier and several analysts now. Timberwolf knew what he had to do and just had an instant to do it. He ran to them, footfall after footfall landing in the snow as if in slow motion. The other Trike had reentry burns from head to toe; its armor sullied and chalky white.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "italics"
  }, [_vm._v("Now’s the time to let her die, ")]), _vm._v("Timberwolf thought as he moved, now just steps away from Dr. Tier, who huddled for cover behind a snow drift. "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("I just slow a little…")]), _vm._v(" but then he thought about what he hadn’t told her yet. What she needed to hear from him about what happened on Highland. In his momentary indecision, a few more steps fell one after the other, and then there was no stopping.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "italics"
  }, [_vm._v("Shit. Decision made.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The Trike’s eyes glowed red in its white-raw face, and mist condensed out of its nostrils with the rhythm of a chugging train.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He was in front of them now, Dr. Tier, Conrad, and a few others. He dropped his shoulder to the Trike, and in that instant, it missed a step. Unable to stop, the beast crashed onto its chin, its giant neck cracking. It cartwheeled over them, the heavy mist from its breath washing down just inches above. It bounced when it landed and then rolled over dead.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The survivors dashed for the landing bay, slipping into the protection of the crumbling structure. They scrambled up the rubble on the inside, and the other Trike pounded against the exterior. “We can’t have it following us,” Timberwolf said, sliding back down to the wall. The pounding came again and again, and the beast tore at the metal, widening the gap they had just come through.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Timberwolf met the gaze of its giant eye and stared. “Get!” he ordered. “Get going!” he scolded. The beast pushed against the structure again and then paused, slowly backing up. Then it was waddling away, its claws crunching in the snow and grunting like a dog kicked off the couch. Timberwolf fell back on his haunches, taking a moment’s rest. He opened his mouth and a sour snowflake melted on his tongue, “Place needs some work.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1039773c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/chap_04.vue
// module id = 87
// module chunks = 0